import { useMutation, useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';
import { TUpdateProfile } from '@onesource/schemas';
import axios from '../../common/axios';
import { ENTITY } from './entity';
import { getUsersQueryKey } from '../../common/profile/use-get-profile-query';

export const useUpdateProfileMutation = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (payload: TUpdateProfile & { avatar?: string }) => {
      const req = await axios.patch(`${ENTITY}/profile`, payload);
      return req.data;
    },
    onSuccess: async () => {
      await Promise.all([
        qc.invalidateQueries({ queryKey: getUsersQueryKey() }),
        // Author info (avatar/name) is denormalized into community-hub posts/comments/reactions.
        // Invalidate the whole namespace so cached entries refetch with the updated profile.
        qc.invalidateQueries({ queryKey: ['community-hub'] }),
      ]);

      enqueueSnackbar('Profile updated successfully!', {
        variant: 'success',
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      });
    },
    onError: () => {
      enqueueSnackbar('Unable to update your profile. Please try again.', {
        variant: 'error',
        anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
      });
    },
  });
};
